module.exports = __webpack_public_path__ + "img/img.b6161902.png";